import styled from '@emotion/styled';
import { Button as AntButton, Upload as AntUpload } from 'antd';

export const Upload = styled(AntUpload)``;

export const Button = styled(AntButton)`
  height: 96px;
  width: 288px;
  min-width: 288px;
  font-size: 1.25rem;
  font-weight: bold;

  .button-text {
    color: inherit;
  }

  &:hover {
    .button-text {
      color: inherit;
    }
  }
`;

export const PreviewContainer = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  border: 2px solid #0e2a27;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const RemoveButton = styled(AntButton)`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
  }

  .anticon {
    font-size: 16px;
  }
`;
